import $ from 'jquery'

/* eslint-disable prefer-arrow-callback */
/* eslint-disable indent-legacy */
export function enableScreenLock() {
  $(`body`).css(`overflow`, `hidden`)
  $(`html`).css(`overflow`, `initial`)
}
export function disableScreenLock() {
  $(`body`).css(`overflow`, `unset`)
  $(`html`).css(`overflow`, `unset`)
}
export function showPopup(popupSelector) {
  const $popup = $(`${popupSelector}`)
  $popup && $popup.addClass(`visible`)
}
export function hidePopup(popupSelector) {
  const $popup = $(`${popupSelector}`)
  $popup && $popup.removeClass(`visible`)
}

export function setPopupScreenLock({
  triggerSelector,
  closeButtonSelector = null
}) {
  const $triggerButton = $(`${triggerSelector}`)
  const $closeButton = $(`${closeButtonSelector}`)

  $triggerButton &&
    $triggerButton.each(function(index, element) {
      const target = $(this).data(`target`)
      const $popupUnderlay = $(target).children(`.popup-outer`)

      $(element).on(`click`, function() {
        $(`${target}`).addClass(`visible`)
        showPopup(target)
        enableScreenLock()
      })

      $popupUnderlay.on(`click`, function() {
        const containerIsVisible = $(this)
          .parent()
          .hasClass(`visible`)
        if (containerIsVisible) {
          hidePopup(target)
          disableScreenLock()
        }
      })
    })

  $closeButton &&
    $closeButton.each(function(index, element) {
      $(element).on(`click`, e => {
        e.preventDefault()
        hidePopup(`.popup.full.visible`)
        disableScreenLock()
      })
    })
}
